export default __webpack_public_path__ + "static/media/m_headerImage.190632dc.webp";